import React from 'react';
import _ from 'lodash';
import ReactApexChart from 'react-apexcharts';

import { useTheme, styled } from '@mui/material/styles';
import { Card, CardContent, CardHeader, Stack } from '@mui/material';

import { BaseOptionChart } from '../../../components-core/chart';

const CHART_HEIGHT = 300;
const LEGEND_HEIGHT = 72;

const ChartWrapperStyle = styled('div')(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(5),
  '& .apexcharts-canvas svg': { height: CHART_HEIGHT },
  '& .apexcharts-canvas svg,.apexcharts-canvas foreignObject': {
    overflow: 'visible'
  },
  '& .apexcharts-legend': {
    height: LEGEND_HEIGHT,
    alignContent: 'center',
    position: 'relative !important',
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`
  }
}));

// ----------------------------------------------------------------------

export const EventSlotsAvailabilityChart = props => {
  const { data } = props;
  const theme = useTheme();

  const chartOptions = _.merge(BaseOptionChart(), {
    colors: [
      theme.palette.primary.main,
      theme.palette.chart.blue[0],
      theme.palette.chart.violet[0],
      theme.palette.chart.yellow[0]
    ],
    labels: ['Wolne miejsca', 'Zajęte miejsca'],
    stroke: { colors: [theme.palette.background.paper] },
    legend: { floating: true, horizontalAlign: 'center' },
    dataLabels: { enabled: true, dropShadow: { enabled: false } },
    plotOptions: {
      pie: { donut: { labels: { show: false } } }
    }
  });

  return (
    <>
      {_.map(data, (obj, key) => (
        <Card key={key} sx={{ mt: 5 }}>
          <CardHeader title={obj.event} titleTypographyProps={{ variant: 'h4' }} />
          <Stack direction="row" flexWrap="wrap">
            {_.map(obj.data, (slot, key) => (
              <Card sx={{ height: '450px' }} key={key}>
                <CardHeader title={slot.camp_name} />
                <CardContent>
                  <ChartWrapperStyle dir="ltr">
                    <ReactApexChart type="pie" series={[slot.free_slots, slot.reserved_slots]} options={chartOptions} width={300} />
                  </ChartWrapperStyle>
                </CardContent>
              </Card>
            ))
            }
          </Stack>
        </Card>
      ))
      }
    </>
  );
};
